import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'next-i18next';
import { useMediaQuery } from 'react-responsive';
import cn from '../../../../../src/utils/cn';
import useWeekId from '../../../../../src/hooks/useWeekId';

// Components
import Tooltip from '../../../../atoms/Tooltip/Tooltip';

import styles from './SelectedPeriods.module.scss';

function SelectedPeriods({ pack, offers, allSoldOut }) {
  const { t } = useTranslation(['common']);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { getOfferDatesFromWeekId } = useWeekId();

  // sorting dates from closest to farthest to now
  // weekId is primary key in DB on weeks table
  offers.sort((a, b) => a.weekId - b.weekId);

  return (
    allSoldOut(offers) ? (
      <p className={`${styles.all_out} fs-14 fw-500`}>
        {t('camp.full')}
      </p>
    ) : (
      offers.length > 2 ? (
        <li className="flex d-col a-end mobile-a-start text-c-secondary fw-500 fs-14">
          <span className={cn([offers[0].flag === 'SOLD_OUT' ? styles.sold_out : '', 'm-b-2'])}>
            {getOfferDatesFromWeekId({
              weekId: offers[0].weekId,
              isWeekend: pack.durationId === 2,
              days: pack.days,
              withShortMonth: true,
            })}
          </span>

          <span className={cn([offers[1].flag === 'SOLD_OUT' ? styles.sold_out : '', 'm-b-5'])}>
            {getOfferDatesFromWeekId({
              weekId: offers[1].weekId,
              isWeekend: pack.durationId === 2,
              days: pack.days,
              withShortMonth: true,
            })}
          </span>

          <div
            data-tip={`
            <div>
            ${offers
              .filter((_, i) => i > 1)
              .map((offer) => `
              <span class='${offer.flag === 'SOLD_OUT' ? 'line-through' : ''}'>
              ${getOfferDatesFromWeekId({
                weekId: offer.weekId,
                isWeekend: pack.durationId === 2,
                days: pack.days,
                withShortMonth: true,
              })}
              </span>
            `)
              .join('<br/>')}
            </div>`}
            data-for="showAllWeeksInPack"
            className={cn([
              styles.more_dates,
              'more-dates m-t-8',
              isMobile ? 'left' : '',
            ])}
          >
            {`+ ${offers.length - 2}`}
            <Tooltip id="showAllWeeksInPack" effect="solid" />
          </div>
        </li>
      ) : (
        offers.map((offer, i) => (
          <li
            key={i}
            className={cn([
              offer.flag === 'SOLD_OUT' ? styles.sold_out : '',
              'text-c-secondary fw-500 fs-14',
            ])}
          >
            {getOfferDatesFromWeekId({
              weekId: offer.weekId,
              isWeekend: pack.durationId === 2,
              days: pack.days,
              withShortMonth: true,
            })}
          </li>
        ))
      )
    )
  );
}

SelectedPeriods.propTypes = {
  pack: PropTypes.shape({}),
  offers: PropTypes.arrayOf(PropTypes.shape({})),
  allSoldOut: PropTypes.func.isRequired,
};

SelectedPeriods.defaultProps = {
  pack: {},
  offers: [],
};

export default SelectedPeriods;
